import { Component, Input } from "@angular/core";
import { ButtonDirective } from "@components";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-menu-item",
  templateUrl: "./menu-item.component.html",
  standalone: true,
  imports: [ButtonDirective, TranslateModule],
  styleUrls: ["./menu-item.component.scss"],
})
export class MenuItemComponent {
  @Input() title = "";
}
